<script setup lang="ts">
import { useHomeSections } from '~/composables/apostatudo/use-home-sections';
import { useModalStore } from '@/stores/apostatudo/modal';
import AnnouncementModal from '@/components/apostatudo/organisms/AnnouncementModal.vue';

const title = computed(() => {
  return `${appName()} 🍀 Cassino e Apostas Online | Apostas Esportivas`;
});

const description = computed(() => {
  return `${appName()} — apostas esportivas e jogos online autorizados. Plataforma segura com saque rápido. 18+ | Jogue com responsabilidade.`;
});

useSeo({
  title: title.value,
  description: description.value,
});

const { isHomeAsSportbookEnabled } = useFeatureFlagsNew();

const { fetchHomeSections, hasItems, hasCategories } = useHomeSections();

const isHomeReady = computed(() => hasItems.value || hasCategories.value);
const apiCheckDone = ref(false);

const route = useRoute();
const modalStore = useModalStore();

// Aviso da home: abre toda vez que o usuário entra na home. Não persiste flag —
// é intencionalmente recorrente. Não abre quando a home foi acessada para abrir
// outro modal (story/giratudo/register), que disputam o mesmo slot único.
function openHomeAnnouncement() {
  if (route.query.open || route.query.register) {
    return;
  }

  modalStore.open(AnnouncementModal);
}

onMounted(async () => {
  openHomeAnnouncement();

  if (isHomeAsSportbookEnabled.value) {
    return;
  }

  await fetchHomeSections();
  apiCheckDone.value = true;
});

// Cobre o caso de a home ficar em keep-alive: ao voltar pra ela, reabre o aviso.
onActivated(() => {
  openHomeAnnouncement();
});
</script>

<template>
  <template v-if="isHomeAsSportbookEnabled">
    <PagesSports />
  </template>

  <template v-else>
    <PagesHomeSkeleton v-if="!apiCheckDone" />

    <PagesHomeV2 v-else-if="isHomeReady" />

    <PagesHome v-else />

    <ApTitleHome />
  </template>
</template>
